import { apiGet, apiPatch, apiPost } from '../client';
import {
  BusinessServiceListResponseSchema,
  BusinessServiceRecordSchema,
  type BusinessServiceRecord,
} from '../schemas';

export function listServices(includeInactive: boolean): Promise<{ data: BusinessServiceRecord[] }> {
  const query = includeInactive ? '?includeInactive=true' : '';
  return apiGet(`/v1/business/services${query}`, BusinessServiceListResponseSchema);
}

export type CreateServiceInput = {
  name: string;
  description?: string;
  priceCents: number;
  durationMin: number;
  isTransactional?: boolean;
};

export function createService(
  input: CreateServiceInput,
  idempotencyKey: string,
): Promise<BusinessServiceRecord> {
  return apiPost('/v1/business/services', BusinessServiceRecordSchema, input, idempotencyKey);
}

export type PatchServiceInput = {
  name?: string;
  description?: string;
  priceCents?: number;
  durationMin?: number;
  isActive?: boolean;
  /** The version the form read; a stale one comes back 409 version_conflict. */
  expectedVersion?: number;
};

export function patchService(
  serviceId: string,
  input: PatchServiceInput,
  idempotencyKey: string,
): Promise<BusinessServiceRecord> {
  return apiPatch(
    `/v1/business/services/${encodeURIComponent(serviceId)}`,
    BusinessServiceRecordSchema,
    input,
    idempotencyKey,
  );
}
